import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingService } from 'src/app/services/loading.service';
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [MatProgressSpinner],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {
  private readonly loadingService = inject(LoadingService);

  title = input.required<string>();
  description = input<string>();
  information = input<string>();
  loading = toSignal(this.loadingService.loading$);
}
